export enum RecipientChannel {
  EMAIL = 'Email',
}
